import { dealDamage, addModifier } from '../player.type';
import type { Die } from '../die.type';
import type { Technique } from '../techniques.type';
import type { Player } from '../player.type';
import { StatusEffect } from '../status-effects.type';
import { DieFace } from '../face.type';
import { SoundType } from '../../components/audio.svelte';

export const shield: Technique[] = [
  //shield sword
  {
    ingredients: [DieFace.Shield],
    title: 'Weak Block',
    text: 'Gain 1 Block.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Block, 1);
    },
  },
  {
    ingredients: [DieFace.Shield, DieFace.Shield],
    title: 'Strong Block',
    text: 'Gain 3 Block.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Block, 3);
    },
  },
  {
    ingredients: [DieFace.Shield, DieFace.Shield, DieFace.Shield],
    title: 'Mega Block',
    text: 'Gain 6 Block.',
    tags: ['defence'],
    audio: SoundType.BuffArmour,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      addModifier(source, StatusEffect.Block, 6);
    },
  },
  {
    ingredients: [DieFace.Shield, DieFace.Fist],
    title: 'Shield Bash',
    text: 'Deal damage equal to block value.',
    tags: ['damage'],
    audio: SoundType.AttackBlunt,
    activate: (target: Player, source: Player, dice: Array<Die>) => {
      var modifier = source.statusEffects.find((modifier) => {
        return modifier.type == StatusEffect.Block;
      });

      var value = 0;
      if (modifier) {
        value = modifier.stacks;
      }

      dealDamage({ value: value, target, source, dice });
    },
  },
];
